export type PageMeta = {
  url: string;
  title: string;
  description: string;
};

export const homeMeta: PageMeta = {
  url: '/',
  title: 'AILiveSim: Software supplier for automation of vehicles',
  description:
    'AI-driven AILiveSim, a premier software supplier, specializing in vehicle automation. Transform your processes with our advanced AI solutions.',
};

export const platformMeta: PageMeta = {
  url: '/platform',
  title: 'Efficient & Scalable Simulation Ecosystem | AILiveSim',
  description:
    "Experience AILiveSim's powerful suite of editors for precise control and automation. From local to cloud simulation, debug, analyze, and optimize scenarios effortlessly.",
};

export const careersMeta: PageMeta = {
  url: '/company/careers',
  title: 'Bring AI Forward With Us',
  description:
    'At AILiveSim, we are shaping the future of artificial intelligence through simulation. Join our innovative team and make an impact on industries from defense to robotics, maritime to automotive.',
};

export const aboutMeta: PageMeta = {
  url: '/company/about-us',
  title: 'From Startup Spirit to Global Recognition',
  description:
    'Founded in Finland, AILiveSim grew from a bold idea into an award-winning company shaping the future of AI through simulation.',
};

export const policyMeta: PageMeta = {
  url: '/privacy-policy',
  title: 'Privacy Policy',
  description: 'Contact information in privacy related matters: AILiveSim Oy / info@ailivesim.com',
};

export const autoDockingMeta: PageMeta = {
  url: '/auto-docking',
  title: 'Accelerate AI Innovation with Simulation-in-the-Loop | AILiveSim Early Access',
  description:
    'AILiveSim helps AI teams accelerate development and testing with intelligent simulation and automated data pipelines. Join AILiveSim’s Early Access Program to train smarter models, validate at scale, and streamline deployment across maritime, defense, automotive, aerospace, and more. Only 10 spots available—apply now! ',
};

export const automatedDataPipelinesMeta: PageMeta = {
  url: '/automated-data-pipelines',
  title: 'Automate Your Maritime AI Training with Intelligent Simulation | AILiveSim Early Access',
  description:
    'Stop chasing costly real-world data. Join AILiveSim’s Early Access Program to automate your maritime AI pipeline with intelligent simulation and synthetic data. Only 10 spots available—apply now to boost detection accuracy, accelerate training, and shape the future of maritime AI.',
};

export const resourcesMeta: PageMeta = {
  url: '/resources',
  description:
    'Stay up to date with the latest news, expert articles, and real-world case studies on AI simulation, synthetic data, and autonomous systems.',
  title: 'AILiveSim News, Articles & Case Studies',
};

// Application
export const applicationsMeta: PageMeta = {
  url: '/all-applications',
  title: 'Smarter Simulation Applications for Every AI Challenge',
  description: '',
};

export const intelligentSystemTestingApplicationMeta: PageMeta = {
  url: '/applications/intelligent-system-testing',
  title: 'Intelligent System Testing',
  description: '',
};

export const intelligentDataPipelineApplicationMeta: PageMeta = {
  url: '/applications/intelligent-data-pipeline',
  title: 'Intelligent Data Pipeline',
  description: '',
};

export const automaticDatasetEnhancementApplicationMeta: PageMeta = {
  url: '/applications/automatic-dataset-enhancement',
  title: 'Automatic Dataset Enhancement',
  description: '',
};

export const reinforcementLearningApplicationMeta: PageMeta = {
  url: '/applications/reinforcement-learning',
  title: 'Reinforcement Learning',
  description: '',
};

// Customer cases
export const customerCaseMeta: PageMeta = {
  url: '/all-customer-cases',
  title: 'Proven Simulation Solutions Across Industries',
  description: '',
};

export const airbusHelicopterCustomerCaseMeta: PageMeta = {
  url: '/customer-case/anti-collision-systems',
  description:
    'Discover how AILiveSim replaces risky field tests by simulating extreme weather, terrain & obstacles for AI anti-collision systems. Dive into the case and book a demo today.',
  title: 'Advancing Helicopter Safety through Next-Gen Simulation',
};

export const hondaMarineCustomerCaseMeta: PageMeta = {
  url: '/customer-case/streamlining-auto-docking',
  description:
    "See how a top maritime OEM cut field-testing costs and speed AI auto-docking with AILiveSim's marina simulation. Read the case & book a demo today.",
  title: 'Streamlining Auto-docking',
};

export const brunswickUseCaseCustomerCaseMeta: PageMeta = {
  url: '/customer-case/ai-powered-auto-docking',
  description:
    'See how AILiveSim let a top marine OEM de-risk AI auto-docking by simulating winds, waves & obstacles. Explore the case and book a demo today.',
  title: 'Launching Smarter Auto-Docking',
};

export const airbusUpNextCustomerCaseMeta: PageMeta = {
  url: '/customer-case/autonomous-aircraft-taxiing',
  description:
    'Discover how AILiveSim slashed dev cycles and boosted safety with multi-sensor Digital Airport Twins. Explore the full case and book a demo today.',
  title: 'Digital Airport Twins Power Autonomous Taxiing',
};
